import React from 'react';
import { Helmet } from 'react-helmet';

const Seo = () => {
  return (
    <Helmet title="Utekirke">
      <meta name="utekirkelogokors" content="../static/utekirkelogokors.png" />
      <meta name="description" content="Utekirke er et moderne læringsverktøy på mobilen som motiverer til aktiviteter og refleksjonssamtaler mens en går fra post til post. Del opp i grupper, finn poster i felleskap og løs oppgaver underveis. Det blir enkelt å lage spennende uteopplegg og vandringer for barn, unge eller voksne." />
      <link rel="icon" type="image/png" href="utekirkelogokors" />
    </Helmet>
  );
};

export default Seo;
